module.exports = __webpack_public_path__ + "static/media/academic-smart.2aa82f44.svg";